import { useNode, useEditor } from "@craftjs/core";
import React from "react";
import GrigoraCSSRenderer from "./../css-render";
import { YoutubeSettings } from "./settings";
import icon from "./icon";
import getVideoId from "get-video-id";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import { CMSYoutubeSettings } from "./cms-settings";
import { EmbedOverlay } from "../../block-helpers";
export const Youtube = (props) => {
  const {
    id,
    connectors: { connect, drag },
    actions: { setProp },
    selected,
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    query: { node },
    actions: { selectNode },
  } = useEditor();

  const {
    url,
    title,
    muted = false,
    autoplay = false,
    showControls = true,
    disableCookies = false,
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-youtube": true,
      [`youtube-${id}`]: id,
      "g-embed": true,
    },
    blockProps.className,
  );

  var embedURL = url
    ? `https://www.youtube${disableCookies ? "-nocookie" : ""}.com/embed/${
        getVideoId(url).id
      }?autoplay=${autoplay ? "1" : "0"}&mute=${muted ? "1" : "0"}&controls=${
        showControls ? "1" : "0"
      }`
    : "";

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      onFocus={() => {
        selectNode(id);
      }}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__Youtube(id, props)}`}</style>
      {url ? (
        <iframe
          title={title}
          allow={`encrypted-media; ${autoplay ? "autoplay;" : ""}`}
          className="youtube-video-frame"
          src={embedURL}
        ></iframe>
      ) : (
        <span>Add Youtube video</span>
      )}
      <EmbedOverlay id={id} selectNode={selectNode} selected={selected} />
    </div>
  );
};

// To Avoid Mangling in Production
Youtube.displayName = "Youtube";

Youtube.craft = {
  name: "Youtube",
  props: {},
  related: {
    CMSsettings: CMSYoutubeSettings,
    settings: YoutubeSettings,
    icon: icon,
    category: "miscellaneous",
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    keywords: ["Youtube"],
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "Youtube",
    slug: "grigora/youtube",
  },
};
